import { Component, OnInit, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import _ from "lodash";
import { ModalService } from "@root/router/index/modal.service";
import { UploadVoucherService } from "./upload-voucher.service";
import { Translate } from "@root/util/decorator";

interface IFile {
  id?: null;
  url: string;
}

export const UPLOAD_VOUCHER_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UploadVoucherComponent),
  multi: true,
};

/** @deprecated */
@Component({
  selector: "host-upload-voucher",
  templateUrl: "./upload-voucher.component.html",
  styleUrls: ["./upload-voucher.component.scss"],
  providers: [UPLOAD_VOUCHER_ACCESSOR],
})
export class UploadVoucherComponent implements OnInit, ControlValueAccessor {
  constructor(
    private messageService: NzMessageService,
    private globalModalService: ModalService,
    private httpService: UploadVoucherService,
  ) {}
  private readonly maxSize = 10;
  listOfImage: Array<IFile> = [];

  @Translate("component.upload.image_format_restrictions") extLimitWarning;
  @Translate("component.upload.image_number_reached_limit") amountLimitWarning;
  @Translate("warning.upload_image_too_large") sizeLimitWarning;
  emitChange = (p: any) => {};
  beforeUpload = (file) => {
    console.log("come here: file: ", file);
    const size = file.size;
    const type = file.type;

    if (["image/jpeg", "image/jpg", "image/png"].indexOf(type) === -1) {
      // this.messageService.info('只允许上传jpg和png格式的图片');
      this.messageService.info(this.extLimitWarning);
      return false;
    }

    if (this.listOfImage?.length >= this.maxSize) {
      // this.messageService.info('上传图片数量已达上限');
      this.messageService.info(this.amountLimitWarning);
      return false;
    }

    if (size > 10 * 1024 * 1024) {
      // this.messageService.info('图片过大，请选择小于10M的图片上传！');
      this.messageService.info(this.sizeLimitWarning);
      return false;
    }

    return true;
  };

  writeValue(images: Array<IFile> = []): void {
    console.log("images:", images);
    if (images) {
      this.listOfImage = images;
    }
  }
  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit() {}

  // onClickImage(url) {
  //   this.globalModalService.displayImageMagnifier(url);
  // }

  onDeleteImage(img) {
    _.remove(this.listOfImage, (image) => image === img);

    this.emitChange(this.listOfImage);
  }
  handleChange(result) {
    const file = result.file;
    if (file.status === "done") {
      const resFile = _.get(file, "response.data.file");
      const url = resFile.original_url;

      const image = { url };
      this.listOfImage = _.concat(this.listOfImage, image) as any;
      this.requestCreateInvoice(image);
      // this.emitChange(_.map(this.listOfImage, 'url'));
    }
  }

  requestCreateInvoice(img) {
    this.httpService.createInvoice({ url: img.url }).subscribe((res) => {
      if (res.error_code === 0) {
        img.id = res.data.id;
      }
      console.log("this.listOfImage: ", this.listOfImage);

      this.emitChange(this.listOfImage);
    });
  }
}
